export default "__VITE_ASSET__XquU1fvR__"